var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerPart'),_c('firstPart'),_c('secondPart'),_c('thirdPart'),_c('footerPart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }